import { useBreakpoint } from '../../styles/breakpoints';
import styled from 'styled-components';
import { FlexContainer } from './Layout';
import { Colors } from '../..';

export const Headline1 = styled.h1`
	font-size: 1.875rem;
	line-height: 1.2;
	font-weight: 700;
`;

export const Headline2 = styled.h2`
	font-size: 1.875rem;
	line-height: 1.2;
	font-weight: 700;
`;

export const Headline3 = styled.h3`
	font-size: 1.375rem;
	line-height: 1.2;
	font-weight: 700;
`;

export const Headline4 = styled.h4`
	font-size: 1.25rem;
	line-height: 1.2;
	font-weight: 700;
`;

export const Headline5 = styled.h5`
	font-size: 1.125rem;
	line-height: 1.22;
	font-weight: 700;
`;

export const Headline6 = styled.h6`
	font-size: 1rem;
	line-height: 1.25;
	font-weight: 700;
`;

export const TextDefault = styled.div`
	font-size: 1rem;
	line-height: 1.25;
	font-weight: 400;
`;

export const TextSmall = styled.div`
	font-size: .875rem;
	line-height: 1.2;
	font-weight: 400;
`;

export const TextTiny = styled.div`
	font-size: .75rem;
	line-height: 1.25;
	font-weight: 400;
`;

export const FontColor = styled(FlexContainer)<{ color: string }>`
  color: ${({ color = Colors.grayDark }) => color }
`;
